module.exports = {

	headView: {
		headView_lbl0: '官方主页',
		headView_lbl1: '预约主页',
		headView_lbl2: '我的主页',
		headView_lbl3: '登录',
		headView_lbl4: 'Languages',
		headView_lbl5: '日语',
		headView_lbl6: '中文',
		headView_lbl7: '06-6710-9972',
		headView_lbl8: '营业时间：9:00〜19:00（18:00最终受理）休息日：全年无休',
		headView_lbl9: '我的主页',
		headView_lbl10: '退出登录',
		headView_lbl11: '确定要登出吗？',
		headView_lbl12: '确定',
		headView_lbl13: '取消',
		headView_lbl14: '英文',

	},

	calendar: {
		calendar_lbl0: 'Reserve from Calendar',
		calendar_lbl1: '车行预约-请点击希望预约的日期。',
		calendar_lbl2: 'Car Line Up',
		calendar_lbl3: '选择车型',
		calendar_lbl4: '休息日无法预约车辆。',
		calendar_lbl5: '过去时间无法预约。',
		calendar_lbl6: '网络连接失败。请刷新网页并重试！',


	},

	carline: {
		carline_1: 'Car Line Up',
		carline_2: '可预约的车型',
		carline_3: '查看车型详情'
	},
	buttom: {

		buttom_lbl0: '乘坐电车来店的客人，店员可在JR或大阪地下铁的[大正站]迎接。',
		buttom_lbl1: '邮编：551-0031 大阪府大阪市大正区泉尾4丁目12-21',
		buttom_lbl2: '© 2022 MR.HIROレンタカー All Rights Reserved.',

	},
	login: {

		login_lbl0: 'Login',
		login_lbl1: '会员登陆',
		login_lbl2: '保持登录状态',
		login_lbl3: '登录',
		login_lbl4: '未持有账号的用户现可马上注册!',
		login_lbl5: '忘记密码',
		login_lbl6: '表单验证失败',
	},
	carlinedetail: {
		carline_1: '查看日历',
		carline_2: '可乘人数',
		carline_3: '变速箱',
		carline_4: '方向盘',
		carline_5: '排气量',
		carline_6: '最高马力',
		carline_7: '适乘人数',
		carline_8: '驱动方式',
		carline_9: '长×宽×高',
		carline_10: '选装',
		carline_11: '备注栏',
		carline_12: '车辆相关信息管理人专用备注栏。',
		carline_13: '◯◯◯◯◯◯◯◯◯◯◯◯◯',
		carline_14: '预约此车辆',
		carline_15: '游客登陆预约',
		carline_16: '会员登录预约',
		carline_17: '套餐'
	},
	ReserveCar: {
		ReserveCar_1: 'Reserve',
		ReserveCar_2: '预约',
		ReserveCar_3: '预约车型',
		ReserveCar_4: '预约日',
		ReserveCar_5: '预约开始时间',
		ReserveCar_6: '预约套餐',
		ReserveCar_7: '延长多日预约',
		ReserveCar_8: '乘坐人数',
		ReserveCar_9: '乘坐人数（未满6岁的儿童）',
		ReserveCar_10: '姓',
		ReserveCar_11: '名',
		ReserveCar_12: '电话号码',
		ReserveCar_13: '邮箱地址',
		ReserveCar_14: '邮箱地址（确认）',
		ReserveCar_15: '国际或地域',
		ReserveCar_16: '驾照种类',
		ReserveCar_17: '车辆保险',
		ReserveCar_18: '支付方式',
		ReserveCar_19: '驾照取得年数',
		ReserveCar_20: '追加 ※400km ',
		ReserveCar_21: '日本驾驶执照',
		ReserveCar_22: 'SOFA License for USFJ',
		ReserveCar_23: 'Switzerland, Germany, France, Taiwan, Belgium, Slovenia, Monaco Domestic Driving License with Japanese Translation by authorizedorganization.',
		ReserveCar_24: 'International Driving Permit by the 1949 Geneva Convention',
		ReserveCar_25: '预付款（信用卡）',
		ReserveCar_26: '当日付款（可接受信用卡和现金）',
		ReserveCar_27: '卡号',
		ReserveCar_28: '安全码',
		ReserveCar_29: '有效期限（月/年）',
		ReserveCar_30: '信用卡名义人（名）',
		ReserveCar_31: '信用卡名义人（姓）',
		ReserveCar_32: '邮箱地址',
		ReserveCar_33: '电话号码',
		ReserveCar_34: '驾照取得年数3年以上',
		ReserveCar_35: '前往确认画面',
		ReserveCar_36: '使用过的信用卡',
		ReserveCar_37: '没有数据',
		
		ReserveCar_38: '驾照取得年数未满3年',
		
		ReserveCar_39:'驾照取得年数未满3年的情况只能选择高级保险套餐。',
		
		ReserveCar_40:'选择{name}的情况只能选择高级保险套餐。',
		ReserveCar_41:'非常感谢您的预约。本店原则上不接受驾照取得时间未满3年以上客户的预约。',
		ReserveCar_42:'假照未满3年但是希望预约的客户可直接来店或致电本店咨询',
		ReserveCar_43:'06-6710-9972',
		ReserveCar_44:'邮编：551-0031',
		ReserveCar_45:'大阪府大阪市大正区泉尾4丁目12−21',
		ReserveCar_46:'营业时间：9:00〜19:00（18:00最终受理）休息日：全年无休',
		ReserveCar_47:'非常感谢您的预约。本店原则上不接受选择海外【驾照名称】的客户的预约',
		ReserveCar_48:'希望预约的客户可通过邮件咨询',
		ReserveCar_49:'06-6710-9972',
		ReserveCar_50:'mrhirojdm@gmail.com',
		ReserveCar_51:'邮编：551-0031',
		ReserveCar_52:'大阪府大阪市大正区泉尾4丁目12−21',
		
		ReserveCar_53:'营业时间：9:00〜19:00（18:00最终受理）休息日：全年无休',
		ReserveCar_54:'若实际驾驶执照取得时间未满3年的情况下，选择了驾驶执照取得时间3年以上并进行车辆预约了的情况下，原则上无法在本司租借车辆。且会产生对应的预约取消违约金。请慎重确认好自身驾驶执照取得时间是否满足预约条件后在进行车辆的预约。',
		ReserveCar_55:' (仅限工作日)※100km ',
		ReserveCar_56:' ※200km ',
		ReserveCar_57:' ※350km ',
		ReserveCar_58:' ※400km ',
		ReserveCar_59:'※每个方案都有距离限制。每超过1公里将收取500日元。',
		ReserveCar_60:'确认使用条款',
		ReserveCar_61:'如果发生违规行为（※参考第18条使用规定）导致事故，可能会支付￥{pay}日元作为车辆费用，因此不在保险范围内。',
		ReserveCar_62:'是的',
		ReserveCar_63:'同意',
		ReserveCar_64:'确认事项',
		ReserveCar_65:'超时费用方面，下午7点前每超10分钟收费1000日元；下午7点后每超10分钟收费2000日元。',
		ReserveCar_66:'受理时间需要约30分钟，该时间包含在租赁时间中，敬请谅解。',
		ReserveCar_67:'服务内容',
		ReserveCar_68:'拍照服务(15张/19,800日元)',
		ReserveCar_69:'摄影服务(约120秒/34,500日元)',
		ReserveCar_70:'照片效果浏览',
		ReserveCar_71:'摄影效果浏览',
		ReserveCar_72:'可选项目：',
		ReserveCar_73:'儿童座椅免费（0日元）',
		ReserveCar_74:'（0至6岁以下幼儿必须使用）',
		ReserveCar_75:'拍照或视频的选项对应的使用费用需在租车费用之外，在当天店面支付。',
		ReserveCar_76:'如果您预订的时间无法使用该选项，我们将通过电子邮件另行通知您，而不是在预订确认邮件中告知。',
		ReserveCar_77:'（21岁以上）'
	},

	ResetPassword: {
		ResetPassword_lbl0: '注册用户',
		ResetPassword_lbl1: '忘记密码',
		ResetPassword_lbl2: '邮箱地址',
		ResetPassword_lbl3: '邮箱验证码',

		ResetPassword_lbl4: '取得验证码',
		ResetPassword_lbl5: '密码必须为6位~18位且含大小写及数字。',
		ResetPassword_lbl6: '登录',
		ResetPassword_lbl7: '密码',

	},

	Register: {
		Register_lbl0: 'Sign Up',
		Register_lbl1: '注册用户',
		Register_lbl2: '邮箱地址',
		Register_lbl3: '邮箱验证码',
		Register_lbl4: '取得验证码',
		Register_lbl5: '密码',
		Register_lbl6: '密码必须为6位~18位且含大小写及数字。',
		Register_lbl7: '我已阅读并同意用户协议。',
		Register_lbl8: '登录',
		Register_lbl9: '已持有账号的用户',
		Register_lbl10: '登录',
		Register_lbl11: '请点击',


		Register_lbl12: '请输入邮箱地址',
		Register_lbl13: '请输入正确的邮箱地址',
		Register_lbl14: '请输入验证码',
		Register_lbl15: '请输入密码',
		Register_lbl16: '登录完成',
		Register_lbl17: '登录并阅读同意以下的用户协议',
		Register_lbl18: '已登录',
		Register_lbl19: '该用户不存在',
		Register_lbl20: '请输入正确的密码',
		Register_lbl21: '网络连接错误',
		Register_lbl22: '该用户已存在',
		Register_lbl23: '登录失败',
		Register_lbl24: '密码已更换',
		Register_lbl25: '未能更换密码',
		Register_lbl26: '确认密码输入不正确',
		Register_lbl27: '请输入姓',
		Register_lbl28: '请输入名',
		Register_lbl29: '发送验证码',
	},

	Reservesure: {
		Reservesure_1: '合 计',
		Reservesure_2: '预约此内容',
		Reservesure_3:'无',
		Reservesure_4:'修正此内容'
	},
	Reservesub: {
		Reservesub_1: 'Thank You !',
		Reservesub_2: '您已成功预约',
		Reservesub_3: '已将【预约完成邮件通知】发送到您登录的邮箱',
		Reservesub_4: '请您查收',
		Reservesub_5: '您预约失败',
		Reservesub_6: '请您到UNIVAPAY上查看支付失败的原因',
		Reservesub_7: '请您重新预约',
	},
	infoview: {
		infoview_1: 'MENU',
		infoview_2: '用户详情',
		infoview_3: '关于您的订单',
		infoview_4: '更改密码',
		infoview_5: '我的积分'
	},
	UserInfo: {
		UserInfo_1: 'User Information',
		UserInfo_2: '用户详情',
		UserInfo_3: '邮箱地址',
		UserInfo_4: '电话号码',
		UserInfo_5: '姓',
		UserInfo_6: '名',
		UserInfo_7: '身份证',
		UserInfo_8: '身份证号',
		UserInfo_9: '出生年月',
		UserInfo_10: '紧急联络人姓名',
		UserInfo_11: '紧急联络人电话号码',
		UserInfo_12: '登录',
		UserInfo_13: '信用卡详情',
		UserInfo_14: '已登录',
		UserInfo_15: '未登录',
		UserInfo_16: '变更信用卡信息',
		UserInfo_17: '登录信用卡',
		UserInfo_18: '变更信用卡信息',
		UserInfo_19: '请输入信用卡号',
		UserInfo_20: '请输入安全码',
		UserInfo_21: '请输入信用卡名义人（名）',
		UserInfo_22: '请输入信用卡名义人（姓）',
		UserInfo_23: '请输入邮箱地址',
		UserInfo_24: '电话号码',
		UserInfo_25: '已成功登录',
	},
	OrderInfo: {
		OrderInfo_1: '预约历史',
		OrderInfo_2: '订单号码',
		OrderInfo_3: '车辆种类',
		OrderInfo_4: '租车开始时间',
		OrderInfo_5: '使用时间',
		OrderInfo_6: '支付方式',
		OrderInfo_7: '无',
	},

	ModifyPwd: {
		ModifyPwd_lbl0: '更改密码',
		ModifyPwd_lbl1: '验证码',
		ModifyPwd_lbl2: '发送验证码',
		ModifyPwd_lbl3: '密码',
		ModifyPwd_lbl4: '确认密码',
		ModifyPwd_lbl5: '登录',

	},
	OrderInfoDetail: {
		OrderInfoDetail_1: '合计金额',
		OrderInfoDetail_2: '确认登录一下的内容请点击页面最下方的【预约此内容】来完成预约',
		OrderInfoDetail_3: '人',
		OrderInfoDetail_4:'无'
	},
	Points: {
		Points_1: '查看积分',
		Points_2: '关于积分',
		Points_3: '使用积分',
		Points_4: '积分使用规则',
		Points_5: '赋予积分日期',
		Points_6: '订单种类',
		Points_7: '积分数',
	},
	bx: {
		bx_1: '无车辆补偿保险',
		bx_2: '基本套餐+3000/天',
		bx_3: '安心套餐+5000/天',
		bx_4: '补偿内容',
		bx_5: '对人补偿',
		bx_6: '无限制',
		bx_7: '车辆补偿保险负担金额：',
		bx_8: '维修费用全额负担',
		bx_9: '对物补偿：',
		bx_10: '20万日元',
		bx_11: '人身伤害险1位补偿最高3000万日元：',
		bx_12: '超过上述自负额和赔偿限额的损失将由客户承担。如果事故原因符合无法支付保险金的保险缴费情况，将不会得到赔偿。如果没有警方发出的事故编号，也将不会得到赔偿。',
		bx_13: '在事故或者由用户过失所导致车辆故障的情况下，将由用户负担车辆维修费用等及车辆维修期间无法使用的停滞费。具体费用根据车辆损伤程度及修理所需要的时间，负担的金额会有变动。敬请周知',
		bx_14: '保险补偿制度',
		bx_15: '自行驾驶返回店铺返还车辆的情况下',
		bx_16: '15万日元',
		bx_17: '无法自行驾驶返回店铺返回车辆的情况下',
		bx_18: '30万日元',
		bx_19: '50万日元',
		bx_20: '保险补偿制度',
		bx_21: '如果您没有加入保险，请出示您的汽车保险证书（原件）。如果您不能出示，我们将无法借给您，敬请谅解。',
	},
	bc:{
		bc_1:'请输入电话号码',
		bc_2:'请输入姓',
		bc_3:'请输入名',
		bc_4:'请输入身份证',
		bc_5:'请输入身份证号码',
		bc_6:'请输入出生年月',
		bc_7:'请输入紧急联络人',
		bc_8: '请输入紧急联络人的电话号码',
		bc_9: '请输入正确的密码',
		bc_10: '请输入预约车辆开始时间',
		bc_11: '请选择套餐',
		bc_12: '请选择乘坐人数',
		bc_13: '邮箱地址（确认）',
		bc_14: '邮箱地址输入不一致',
		bc_15: '请输入国际或地区',
		bc_16: '请输入驾驶证的种类',
		bc_17: '请选择保险类型',
		bc_18: '请选择支付方式',
		bc_19: '预约成功',
		bc_20: '预约失败',
		bc_21: '名',
		bc_22: 'cc',
		bc_23:'ps',
		bc_24:'该用户不存在',
		bc_25:'超过指定人数',
		bc_26:'请输入信用卡号码',
		bc_27:'请输安全码',
		bc_28:'请输入信用卡有效期限（月）',
		bc_29:'请输入信用卡有效期限（年）',
		bc_30:'信用卡名义人（名）',
		bc_31:'信用卡名义人（姓）',
		bc_32:'邮箱地址',
		bc_33:'请输入1名以上的乘坐人数',
		bc_34:'请选择驾驶证取得年数',
		bc_35:'登陆失败。请重新确认输入的内容',
		bc_36:'用户名或密码不正确',
		bc_37:'登陆失败。请重新确认输入的内容',
		bc_38:'请输入必须项',
		bc_39:'该邮箱已注册',
		bc_40:'请输入验证码',
		bc_41:'登陆失败。请重试。',
		bc_42:'Password',
		bc_43:'请输入1~12位数字',
		bc_44:'请输入信用卡名义人姓名（姓）',
		bc_45:'请输入信用卡名义人姓名（名）',
		bc_46:'已发送验证码',
		bc_47:'请输入正确的电话号码',
		bc_48:'请输入正确的出生年月日',
		bc_49:'登陆中',
		bc_50:'请稍等',
		bc_51:'预约处理中',
		bc_52:'正在发送',
		bc_53:'请输入争取的验证码',
		bc_54:'请输入正确的有效期限',
		bc_55:'您选择的预约日期已被预约。请重试。',
		bc_56:'请确认使用条款。',
	},
	agree:{
		agree1:'MR.HIRO POINT会员规则',
		agree2:'株式会社日惠（以下简称“本公司”）是一家向完成公司规定程序及规则的会员提供本公司服务（以下简称“服务”）的公司。以下的”ME.HIRO POINT会员协议“（以下简称”会员协议“）内容适用于完成公司规定程序的会员对服务的使用。',
		agree3:'第1条（适用范围）',
		agree4:'此会员协议适用于本司及本司会员对服务的使用',
		agree5:'第2条（术语的定义）',
		agree6:'会员协议中定义的主要术语如下',
		agree7:'(1)「HIROPOINT」是本公司授予HIRO POINT会员的积分名称，作为HIRO POINT授予或使用的单个积分在下文中简称“积分”。',
		agree8:'(2)「HIRO APP」是公司提供的用于注册HIRO POINT会员和使用HIRO POINT的智能手机应用程序。',
		agree9:'(3)「会员ID信息」是指本司约定用户在使用POINT应用程序是所需要的用户ID，密码，电子邮箱地址和其他会员的信息。',
		agree10:'(4)「积分余额」是指通过使用HIRO POINT服务在积分账户中累计的积分数。',
		agree11:'第3条（会员资格）',
		agree12:'(1)准会员应通过POINT App同意公司的会员条款和条件，并按照公司规定的程序注册为会员，一旦会员信息在公司系统中登记，准会员的会员注册即告完成。 但是，如果会员信息有任何遗漏，可能无法完成会员注册。',
		agree13:'(2)如果准会员不同意会员条款和条件，则无法成为会员。 此外，如果你是帮派成员、帮派的准成员、与帮派相关人员、与帮派有关的公司或大会堂或任何其他反社会力量（反社会力量）的成员，则将无法成为成员。 反社会势力（以下简称"反社会势力"）的成员（包括在过去五年内曾是成员的）。 (2）反社会势力（以下简称 "反社会势力"）成员（包括过去五年内的成员）或与反社会势力成员有关的人，以及滥用服务或给第三方造成麻烦的人，不允许使用该服务。"反社会势力"）的成员（包括在过去五年内曾是成员的）。 (2）反社会势力（以下简称 "反社会势力"）成员（包括过去五年内的成员）或与反社会势力成员有关的人，以及滥用服务或给第三方造成麻烦的人，不允许使用该服务。',
		agree14:'(3)如果发现准会员属于第12条规定的任何内容，则不可能进行会员登记。 此外，如果发现有第12条规定的任何内容，即使完成了会员登记，公司也可以暂停或取消其会员资格。',
		agree15:'(4)由于HIRO POINT服务的对象是个人，公司无法成为会员。',
		agree16:'第4条（ID与密码的管理）',
		agree17:'(1)会员自身需承担其个人的账号ID及密码的管理',
		agree18:'(2)会员自身不得允许任何第三方使用其会员身份信息或以任何方式处置该身份信息，包括出借，转让，改名，出售，购买或抵押等。',
		agree19:'(3)关于合法会员信息的任何程序上的手续及操作，本公司将视为会员本人执行。如果第三方使用会员的身份信息造成损失后，会员应承担相应责任，本公司不承担任何损失。',
		agree20:'(4)若会员得知其会员身份信息被泄露，或其会员身份信息被第三方使用，应及时联系本司并遵从本司发出的指示。',
		agree21:'第5条（会员信息或会员身份信息的变更）',
		agree22:'(1)若会员信息或会员身份信息有任何变更时，会员应在POINT APP上更改注册信息或与本公司联系。',
		agree23:'(2)若不按照前款规定进行更改，会员可能无法收到必要的信息或通知，也可能无法获得积分奖励等服务。本司将不对会员因未进行此类修改而造成的任何损失或损害负责。',
		agree24:'第6条（积分的授予）',
		agree25:'本公司将在以下条件下为会员授予积分。此外，根据购买的产品，服务内容或支付方式不同的而不授予积分的情况也会发生。',
		agree26:'(1)在本公司按照规定的程序流程进行的积分购买',
		agree27:'(2)购买前述项目所附带的积分分配',
		agree28:'(3)积分活动或其他本公司进行的发行方法',
		agree29:'第7条（积分的有效期限）',
		agree30:'积分的授予与使用应按照前条规定授予积分之日起6个月之内为有效期，过期视为失效。',
		agree31:'第8条（积分的使用）',
		agree32:'(1)会员可以使用其积分来支付购买公司产品或享用公司服务的全部或部分费用。',
		agree33:'(2)积分不能兑换现金，或退换现金',
		agree34:'第9条（积分禁止转让）',
		agree35:'会员不得将其持有的积分转让或出借给其他人，或为其提供担保。会员不得转让或借用其他会员持有的积分。按照本公司规定的程序进行上述操作的情况除外。',
		agree36:'第10条（积分的取消，失效及修改）',
		agree37:'(1)会员可以使用其积分来支付购买公司产品或享用公司服务的全部或部分费用。',
		agree38:'(2)积分余额应根据通过POINT应用程序记录并储存在本公司系统里的数据（以下简称“数据”）为准。若POINT应用程序上显示的数据与本公司内部显示数据不同的情况下，本公司系统里的数据将视为正确积分余额。',
		agree39:'(3)若本公司错误的授予任何会员积分，或有其他原因需要纠正当前积分余额时，本公司有权进行适当的积分余额调整或调整至正确积分余额的权力。',
		agree40:'(4)若发生以下的任意某事件，该事件发生时的全部积分余额将作为过期，且积分无法使用。已经过期的积分不会因为任何原因被重新重新授予。',
		agree41:'　①　若第7条规定的积分到期日已过的情况',
		agree42:'　②　若该会员推出会员资格或失去会员资格的情况',
		agree43:'　③　若公司在某情况下判断撤销积分为适当和必要的i情况',
		agree44:'第11条（退会）',
		agree45:'会员可在任何时候退会，退会时应遵守公司规定的程序。 在退出程序完成后，任何在退出时获得的积分都将失效。 由于任何原因过期的积分将不会被重新授予。',
		agree46:'第12条（强制退会相关）',
		agree47:'(1)若公司判断怀疑某会员属于以下任何异乡的情况下，本公司有权暂停其会员资格，直至该问题得到解决。若未解决情况下失去其会员资格的情况下，曾授予其会员的任何积分将在失去会员资格的同时失效。',
		agree48:'　①　若该会员违反了会员协议或公司另行规定的任何其他条款和条件',
		agree49:'　②　若该会员按照第11条的规定推出了会员资格',
		agree50:'　③　若该会员被判明是反社会力量（包括该会员在过去五年内曾是反社会力量成员的情况）',
		agree51:'　④　若该会员不存在（包括会员因故死亡的情况）',
		agree52:'　⑤　若该会员在过去因违反会员规则等而被暂停或没收',
		agree53:'　⑥　若该会员在注册过程中向本公司提供的信息有虚假，错误或遗漏',
		agree54:'　⑦　若该会员处于监护，保护或援助之下，且没有获得成年监护人，保护人或助手的同意',
		agree55:'　⑧　若该会员未经授权或其他方式获得积分及使用',
		agree56:'　⑨　若该会员在其他方面公司判断该会员不适合作为会员',
		agree57:'(2)本公司有权取消因向本司登录的地址，电话号码或电子邮箱地址等发生变化而无法哦联系到的会员的资格',
		agree58:'(3)本公司有权取消任何积分余额在最后活动日开始一年后的最后月的月末位置没有任何变化的会员资格',
		agree59:'第13条（服务的暂停与终止）',
		agree60:'(1)在以下的情况下，本公司有权中断或终止对其会员HIRO POINT资格的服务',
		agree61:'　①　HIRO POINT服务所需的设备进行维护或检查时，或故障时',
		agree62:'　②　本公司决定暂停或终止HIRO POINT服务时',
		agree63:'　③　发生任何其他不可控情况时',
		agree64:'(2)本公司不对任何因HIRO POINT服务的中断或终止而给会员造成的任何损失或者其他不利因素负责',
		agree65:'(3)本公司应在HIRO POINT的服务的中断或终止前对会员发出通知。然而本条不适用于本公司发生任何不可控或任何紧急情况',
		agree66:'第14条（会员的个人情报的收集，使用及提供等）',
		agree67:'【同意会员的个人情报的收集，使用及提供等】',
		agree68:'会员同意本公司在采取必要的保障措施后，按照第二段规定的途径收集和使用会员的信息',
		agree69:'【收集，使用及提供的项目】',
		agree70:'本公司将为第三段所述目的使用会员的下列个人信息',
		agree71:'　①　会员在申请入会时提供的各项内容，例如姓名，地址，电话号码，出生年月，性别和电子邮箱地址，以及会员成为会员后提供的各项',
		agree72:'　②　会员与本公司签订合同时填写的相关事项，如入会日期，会员卡号等（包括积分分配和使用历史，购买历史（使用日期和时间，使用店铺，使用金额，购买的产品，付款方式等）与HIRO POINT会员信息相关的各种服务历史等）获得的情报。',
		agree73:'　③　公开获取的信息，如官方公报或电话簿',
		agree74:'　④　使用HIRO POINT APP应用程序时，获取的设备IP地址，位置信息和固态识别号码等信息',
		agree75:'【本公使用个人信息的目的】',
		agree76:'　①　提供HIRO POINT服务的积分提供的服务',
		agree77:'　②　分析HIRO POINT服务的使用情况，并根据客户的兴趣和爱好进行市场调查，并进行产品开发和营销',
		agree78:'　③　分析所获得的浏览历史和购买力是等信息，发送有关本公司极其合作伙伴所经营的业务产品，积分奖励和服务等宣传材料，开发广告，并提供相关的销售信息',
		agree79:'　④　在必要时联系成员进行交易或联络并请确认细节',
		agree80:'　⑤　登记并维护和管理公司会员组织，以及根据第5条规定内容相关',
		agree81:'　⑥　根据法律程序向第三方提供个人信息，以便提供HIRO POINT服务',
		agree82:'　⑦　用于与上诉目的类似或相关的其他目的',
		agree83:'【向第三方提供个人信息】',
		agree84:'本公司将在实现第3条款各项目的必要范围内，向关联公司等提供第2条款所述的会员个人信息。本公司不会接受只向特定的集团或公司或租户提供个人信息而不向其他集团公司或租户提供的建议',
		agree85:'【向第三方提供个人数据的例外情况】',
		agree86:'在以下的情况，个人信息会在未经会员事前同意的情况下提供给第三方',
		agree87:'　①　基于法律规定时',
		agree88:'　②　为保护某人的生命，身体或财产而有必要，且难以获得该成员的同意时',
		agree89:'　③　对改善公共卫生或儿童的健康成长特别必要，且难以获得当事人同意时',
		agree90:'　④　在执行法律规定的事务时，需要与国家机关、地方当局或受其委托的个人或实体合作，而获得有关人员的同意可能会妨碍有关事务的执行时',
		agree91:'【个人情报的外包】',
		agree92:'本公司会发生为实现第3条款所述的使用目的时向本公司业务外包的第三方提供第2条款所述的会员个人信息',
		agree93:'【处理个人信息的分歧】',
		agree94:'若会员在申请入会时不愿意提供必要的信息，或不同意本协议的全部或部分条款时，本公司可以拒绝该会员的资格采用或采取措施取消其会员资格',
		agree95:'【关于会员个人情报的查询窗口】',
		agree96:'关于会员的个人人信息的查询或意见提供请直接联系本公司',
		agree97:'第15条（规则的变更等）',
		agree98:'本公司可以在法律规定的范围内修改会员协议。条款和条件的变更等原则上至少提前60天通过POINT APP应用程序等方式对用户进行通用。若修改内容符合会员的利益情况下则不适用。内容修改后视为最新用户协议并真实有效',
		agree99:'第16条（免责声明）',
		agree100:'(1)除本公司故意为之或严重过失之外的情况下，用户对HIRO POINT使用时造成的任何损失等不承担任何责任',
		agree101:'(2)若本公司承诺对会员在HIRO POINT使用期间造成的损害赔偿承担责任是，本公司赔偿的损害应限于普通或直接的损害。本公司在任何情况况下都不对间接损害，特殊损害，附带损害，利润损失或基会损失等承担任何责任',
		agree102:'第17条（管辖法律）',
		agree103:'会员协议和任何与使用HIRO POINT服务有关的合同的形成，有效性，履行和解释都应收日本法律管辖',
		agree104:'第18条（争端解决）',
		agree105:'若会员和本公司之间出现了与HIRO POINT服务相关的纠纷，且无法解决时，大阪地方裁判所将作为第一审的专属管辖法院',
		agree106:'第19条（强制执行及有效起始时期）',
		agree107:'本会员协议将于日本标准时间2022年12月1日00:00时起生效',
		agree108:'以上'
	}



}
